
import {Vue, Component, Prop} from "vue-property-decorator";
import { Getter } from "vuex-class";
import {formRules} from "@/utils/formRules";

@Component({})
export default class UploadKeysTags extends Vue {

    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;

    private stepOne: boolean = false;
    private rules: object = formRules;
    private stepTwo: boolean = false;
    private stepThree: boolean = false;
    private validEditKeyInfoForm: boolean = false;
    private keyCategories: any[] = [];
    private searchCategory: string = "";
    private keyCategory: any = "";
    private tagsFromCategory: any[] = [];
    private categoryTag: any = {
        fr: "",
        en: "",
        de: "",
        pt: "",
    };
    private buttonValidateStepOne: boolean = false;

    private mounted(): void {
        this.getCategories();
    }

    private async changeModaleStepOneToTwo(): Promise<void> {
      await this.getTags();
      this.stepOne = false;
      this.stepTwo = true;
    }

    private changeModaleStepTwoToThree(): void {
        this.stepTwo = false;
        this.stepThree = true;
    }

    private getCategories(): void {
        this.$store.dispatch("categories/getAll")
            .then((res) => {
                this.keyCategories = res.categories;
            });
    }

    private getTags(): void {
        this.$store.dispatch("categories/getTagsFromCategory", {
             id: this.keyCategory,
        }).then((res) => {
                this.tagsFromCategory = res;
            });
    }

    private saveTag(): void {
        this.$store.dispatch("admin/tags/addTagForCategory", {
            tag: this.categoryTag,
            categoryId: this.keyCategory,
        }).then(() => {
          this.$store.commit("alerts/displaySuccess", {
                  msg: this.$i18n?.t("alerts.key.tagCreated"),
              });
          this.stepThree = false;
      });
    }

    get formattedCategoriesValues(): any[] {
        return this.keyCategories.map((category: any) => {
            return { text: category.fr, value: category.id };
        });
    }

    get formattedTagsValues(): any[] {
        return this.tagsFromCategory.map((tags: any) => {
            return { text: tags.fr, value: tags.id };
        });
    }

    private openDialog(): void {
        this.stepOne = true;
    }
}
